import React, { useState, createContext, useContext } from 'react';
import { translations, Language } from '../i18n/translations';
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: keyof (typeof translations)['es']) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('es');
  const t = (key: keyof (typeof translations)['es']) => {
    return translations[lang][key] || key;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-202">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}